import PropTypes from 'prop-types'
import React from 'react'

const ModalContainer = ({ children }) => (
  <div className="fv-modal-container">{children}</div>
)

ModalContainer.propTypes = {
  children: PropTypes.node
}

export default ModalContainer



// WEBPACK FOOTER //
// ../src/components/fv-ui/ModalContainer.js